// @flow strict
import type { $AxiosXHR } from 'axios';

import axios from 'axios';

type Subject = {|
  subjectId: string,
  subjectDisplay: string,
|};

export type Grade = {|
  gradeId: string,
  gradeDisplay: string,
  availableSubjects: Subject[],
|};

export type State = {|
  stateId: string,
  stateDisplay: string,
  availableGrades: Grade[],
|};

export const getStateList = (): Promise<State[]> => {
  return axios
    .get('/data/partners.json')
    .then((response: $AxiosXHR<mixed, State[]>) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Error loading application data', error);
      return [];
    });
};
